import { useColorMode } from '@chakra-ui/react'
import { TextAreaField } from '@hb/shared'
import { CSSProperties, forwardRef, useMemo } from 'react'
import { InputElement, InputProps } from '../../../../../types/fields'
import InputContainer from '../../Shared/InputContainer'
import { useInputSize } from '../../Shared/sizes'
import { baseInputStyle } from '../../Shared/styles'
import { TextAreaElement } from './styles'

const TextArea: InputElement<TextAreaField> = forwardRef<
  HTMLTextAreaElement,
  InputProps<TextAreaField>
>(({ style, ...props }, ref) => {
  const { input, field, disabled, readOnly, inputStyle, size: sizeProp } = props
  const size = useInputSize(sizeProp ?? field?.size)
  const { colorMode } = useColorMode()
  const { placeholder, optional, minRows = 2 } = field
  const inputPlaceholder = useMemo(
    () => (optional ? `${placeholder} (optional)` : placeholder),
    [placeholder, optional],
  )
  return (
    <InputContainer
      {...props}
      flexProps={{ alignItems: 'flex-start' }}
      style={{
        width: '100%',
        minWidth: '250px',
        maxHeight: '350px',
        overflowY: 'auto',
        ...style,
      }}>
      <TextAreaElement
        ref={ref}
        disabled={disabled}
        readOnly={readOnly}
        style={
          { ...baseInputStyle(size, disabled, colorMode), ...inputStyle } as Omit<
            CSSProperties,
            'height'
          >
        }
        minRows={minRows}
        placeholder={inputPlaceholder}
        withDotPhrases={field.withDotPhrases}
        {...input}
        onFocus={e => {
          // move cursor to end
          const { value } = e.target
          e.target.value = ''
          e.target.value = value
          input?.onFocus(e)
        }}
      />
    </InputContainer>
  )
})

export default TextArea
